// The Pass Details side panel — ported from renderers-shotmap.js passDetailsPanelHtml. All
// values come from passmap-view.ts (pure); this paints them with the legacy's exact markup.

import { Fragment } from "react";
import type { ProtoEvent } from "@catbento/shared";
import type { EventContext } from "../engines/event-map-kit.js";
import { obvChartRows } from "./event-details-view.js";
import { DetailGroup, DivergingBarChart } from "./EventDetailParts.js";
import { passDetails } from "./passmap-view.js";

export function PassDetailsPanel({ ctx, pass }: { ctx: EventContext; pass: ProtoEvent }) {
  const d = passDetails(ctx, pass);
  return (
    <div className="event-detail-grid">
      <DetailGroup label="Opposition" span2>
        <div className="event-detail-value">{d.opposition}</div>
      </DetailGroup>
      <DetailGroup label="Date">
        <div className="event-detail-value">{d.date}</div>
      </DetailGroup>
      <DetailGroup label="Result">
        <div className={`event-detail-value ${d.resultClass}`}>{d.resultText}</div>
      </DetailGroup>
      <DetailGroup label="Time">
        <div className="event-detail-value">{d.time}</div>
      </DetailGroup>
      <DetailGroup label="Outcome">
        <span className={`event-detail-pill ${d.outcomePillClass}`}>{d.outcome}</span>
      </DetailGroup>
      <DetailGroup label="Body Part">
        <span className="event-detail-pill">{d.bodyPart}</span>
      </DetailGroup>
      <DetailGroup label="Type">
        <span className="event-detail-pill">{d.type}</span>
      </DetailGroup>
      <DetailGroup label="Height">
        <span className="event-detail-pill">{d.height}</span>
      </DetailGroup>
      <DetailGroup label="Recipient">
        <div className="event-detail-value">{d.recipient}</div>
      </DetailGroup>
      <DetailGroup label="Key Pass / Assist">
        <div className="event-detail-value">{d.keyPass}</div>
      </DetailGroup>
      <DetailGroup label="Direction">
        <span className="event-detail-pill">{d.direction}</span>
      </DetailGroup>
      <DetailGroup label="Play Pattern">
        <span className="event-detail-pill">{d.playPattern}</span>
      </DetailGroup>
      <DetailGroup label="Success Probability">
        <div className="event-detail-value">{d.successProbability}</div>
      </DetailGroup>
      <DetailGroup label="Characteristics">
        <Tags tags={d.characteristics} />
      </DetailGroup>
      <DetailGroup label="Pass Into">
        <Tags tags={d.passInto} />
      </DetailGroup>
      <DetailGroup label="On-Ball Value (OBV)" span2>
        <DivergingBarChart rows={obvChartRows(pass)} />
      </DetailGroup>
    </div>
  );
}

/** Space-separated pills, or "—" with none (the legacy joins them with ' '). */
function Tags({ tags }: { tags: string[] }) {
  return (
    <div className="event-detail-value event-detail-tags">
      {tags.length
        ? tags.map((t, i) => (
            <Fragment key={t}>
              {i > 0 && " "}
              <span className="event-detail-pill">{t}</span>
            </Fragment>
          ))
        : "—"}
    </div>
  );
}
